/* global angular, moment */
(function () {
  'use strict';

  angular
    .module('vcclient')
    .config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.client', {
        url: '/vcclient',
        views: {
          'playgroundmain@playground': {
            template:
            '<h3 class="alert alert-info"><tt>&lt;patientheader clientid="" mode=""&gt;</tt></h3><div><div ui-view="patientheaderview"></div></div>' +
            '<h3 class="alert alert-info"><tt>&lt;clientsearch parentsave="getclient(client, mode)"&gt;</tt></h3><div ui-view="clientsearchview1"></div>' +
            '<h3 class="alert alert-info"><tt>&lt;clientsearch redirect="home"&gt;</tt></h3><div ui-view="clientsearchview2"></div>' +
            '<h3 class="alert alert-info"><tt>&lt;clientlist clients=""&gt;</tt></h3><div ui-view="clientlistview"></div>' +
            '<h3 class="alert alert-info"><tt>&lt;clientlist mode=""&gt;</tt></h3><div ui-view="clientlistview2"></div>' +
            '<h3 class="alert alert-info"><tt>&lt;clientnew mode="" onCreate: "" onCancel: "" onSelectRecord: "",&gt;</tt></h3><div ui-view="clientnewview"></div>' +
            // '<h3 class="alert alert-info"><tt>&lt;clienteditor client="" mode="" clientcategories=""&gt;</tt></h3><div ui-view="clienteditview"></div>' +
            '<h3 class="alert alert-info"><tt>&lt;clienteditor client="" mode="" clientcategories=""&gt;</tt></h3><div ui-view="clienteditview2"></div>' +
            '<h3 class="alert alert-info"><tt>&lt;svdataedit svdata="" on-change=""&gt;</tt></h3><div ui-view="svdataeditview"></div>' +
            '<h3 class="alert alert-info"><tt>&lt;contactedit contact="" on-change="" &gt;</tt></h3><div ui-view="contacteditview"></div>' +
            '<h3 class="alert alert-info"><tt>&lt;companyedit company="" on-change="" &gt;</tt></h3><div ui-view="companyeditview"></div>' +
            '<h3 class="alert alert-info"><tt>&lt;clientview vcclient=""&gt;</tt></h3><div ui-view="clientview"></div>'
          }
        },
        onEnter: function () {
          console.log('playground.vcclient entered');
        }
      });


    $stateProvider
      .state('playground.client.allcomponents', {
        url: '/allcomponents',
        // the `users` input binding on the component receives
        // the `userlist` resolve value (from the state)
        // bind $transistions to gain access to $transition$ object

        resolve: {
          dummyclients: ['ClientHelper', function (ClientHelper) {
            // return ClientHelper.getAll('patient');
            return getClients();
          }],
          emptysvdata: function () {
            return {};
          },
          dummyclient: function () {
            return getClient(false, false, 'spr');
          },
          teststate: function () {
            return 'playground.vcutilsdoctor.allcomponents';
          },
          emptyclient: function () {
            return {_id: 'somedummyid'};
          },
          patient: function () {
            return 'patient';
          },
          basicdata: function () {
            return 'clientrecord.basicdata';
          },
          home: function () {
            return 'home';
          },
          realpatient: ['ClientHelper', function (ClientHelper) {
            return ClientHelper.find('patient', '58499f4c878f751a3eab5019');
          }],
          realpatientid: function () {
            return '586fcf4fa60359ae2a632d64';
          },
          clientcats: function () {
            return ['foo', 'bar', 'baz'];
          },
          onfieldchange: function () {
            return function (source) {
              console.log('debug: dummy onfieldchange called from: ', source);
            };
          },
          getclient: function () {
            return function (client, mode) {
              console.log('debug - dummy get client called: client, mode: ', client, mode);
            };
          },
          oncreate: function () {
            return function () {
              console.log('debug: dummy oncreate called');
            };
          },
          selectrecord: function () {
            return function () {
              console.log('debug: dummy select record called');
            };
          },
          oncancel: function () {
            return function () {
              console.log('debug: dummy oncancel called');
            };
          },
          onSelectRecord:['$state', function ($state) {
            return function (client, mode) {
              $state.go('clientrecord.basicdata', {client: client, clientid: client._id, mode: mode});
            };
          }],
          onCreate: ['$state', function ($state) {
            return function (client, mode) {
              console.log('debug - onCreate cb with state change called: ', client);
              $state.go('clientrecord.basicdata', {client: client, clientid: client._id, mode: mode});
            };
          }]

        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve
          'patientheaderview@playground.client': {
            component: 'patientheader',
            bindings: {
              clientid: 'realpatientid',
              mode: 'patient'
            }
          },
          'clientlistview@playground.client': {
            component: 'clientlist',
            bindings: {
              clients: 'dummyclients'
            }
          },
          'clientlistview2@playground.client': {
            component: 'clientlist',
            bindings: {
              mode: 'patient',
              redirect: 'basicdata'
            }
          },
          'clientnewview@playground.client': {
            component: 'clientnew',
            bindings: {
              onCreate: 'onCreate',
              onCancel: 'oncancel',
              onSelectRecord: 'onSelectRecord',
              mode: 'patient'
            }
          },
          'svdataeditview@playground.client': {
            component: 'svedit',
            bindings: {
              svdata: 'emptysvdata',
              parentsave: 'onfieldchange("svdata")'
            }
          },
          'contacteditview@playground.client': {
            component: 'contactedit',
            bindings: {
              contact: 'client.primarycontact',
              parentsave: 'onfieldchange("contact")'
            }
          },
          'companyeditview@playground.client': {
            component: 'companyedit',
            bindings: {
              company: 'client.company',
              parentsave: 'onfieldchange("company")'
            }
          },
          'clienteditview2@playground.client': {
            component: 'clienteditor',
            bindings: {
              client: 'realpatient',
              mode: 'patient',
              clientcategories: 'clientcat'
            }
          },
          'clienteditview@playground.client': {
            component: 'clienteditor',
            bindings: {
              client: 'realpatient',
              mode: 'patient',
              clientcategories: 'clientcat'
            }
          },
          'clientsearchview1@playground.client': {
            component: 'clientsearch',
            bindings: {
              mode: 'patient',
              parentsave: 'getclient(client, id, mode)'
            }
          },
          'clientsearchview2@playground.client': {
            component: 'clientsearch',
            bindings: {
              mode: 'patient',
              redirect: 'teststate'
            }
          }/*,
          'clientview@playground.vcclient': {
            component: 'clientview',
            bindings: {
              vcclient: 'vcclient'
            }
          }*/
        },
        /*views: {
         'clientlistview@playground.vcclient': {
         template: 'Some useless Text'
         }
         },*/
        onEnter: function () {
          console.log('playground.client.allcomponents entered');
        }
      });


  }// all routes


  function getClient(istest, iscompany, category) {
    let client = {
      _id: '571d67437c01594fd0bbdf47',
      created: '2016-04-25T00:39:31.368Z',
      test: 'Testexam',
      docid: '571d674d7c01594fd0bbdf48',
      patientid: '571d67207c01594fd0bbdf45'
    };
    client.iscompany = iscompany;
    client.test = istest;
    client.category = category;
    client.primarycontact = getContact(Math.floor((Math.random() * 10) + 1));
    client.svdata = {};
    client.contacts = [{}, {}];
    return client;
  }

  function getContact(num) {
    let pers = {};
    switch (num) {
      case 1: {
        pers.firstname = 'Martha';
        pers.lastname = 'Stuart';
        pers.address = 'Mustergasse 1';
        pers.postcode = '1070';
        pers.city = 'Wien';
      }
        break;
      case 2: {
        pers.firstname = 'Helmut';
        pers.lastname = 'Hofer';
        pers.address = 'Mustergasse 2';
        pers.postcode = '1070';
        pers.city = 'Wien';
      }
        break;
      case 3: {
        pers.firstname = 'Maria';
        pers.lastname = 'Schuster';
        pers.address = 'Mustergasse 3';
        pers.postcode = '1070';
        pers.city = 'Wien';
      }
        break;
      default: {
        pers.firstname = 'Max';
        pers.lastname = 'Default';
        pers.address = 'Mustergasse 99';
        pers.postcode = '1070';
        pers.city = 'Wien';
      }
        break;
    }
    return pers;
  }

  function getClients() {
    return [
      getClient(true, true, 'spr'),
      getClient(true, false, 'spr'),
      getClient(false, true, 'spr'),
      getClient(false, false, 'spr'),
      getClient(true, true, 'other'),
      getClient(true, false, 'other'),
      getClient(false, true, 'other'),
      getClient(false, false, 'other'),
    ];
  }


}());
